import React, { Component } from 'react'
import '../../App.css'
import axios from 'axios'
import {Consumer} from '../../context'

export default class Search extends Component {

    state = {
        trackTitle: ""
    }

    onSongChange(e) {
        this.setState({trackTitle: e.target.value})
    }

    findSong = (dispatch, e) => {

        e.preventDefault();

        axios.get(`https://cors-anywhere.herokuapp.com/http://api.musixmatch.com/ws/1.1/track.search?q_track=${this.state.trackTitle}&page_size=6&page=1&s_track_rating=desc&apikey=${process.env.REACT_APP_API_KEY}`)
            .then(res => {
                dispatch({
                    type: 'SEARCH_TRACK',
                    payload: res.data.message.body.track_list
                })
            })
            .catch(error => console.log(error))

        
    }

    render() {
        return (
            <Consumer>
                {value=>{
                    const {dispatch} = value
                    return (
                        <div className="card card-body mt-4 mb-4 p-4">
                            <h3 className="text-center" style={{fontFamily: 'Source Sans Pro', fontWeight: 'bold'}}>Search</h3>
                            <p className="lead text-center">Search lyrics for your desired song</p>
                            <form onSubmit={this.findSong.bind(this, dispatch)}>
                                <div className="form-group">
                                    <input type="text" className="form-control form-control-lg" placeholder="Song Name"
                                        onChange={this.onSongChange.bind(this)}
                                    />
                                <button className="btn btn-lg btn-block mt-3" style={{backgroundColor: '#2B2B52', color: '#fff'}}>Search</button>
                                </div>
                            </form>
                        </div>
                    )
                }}
            </Consumer>
        )
    }
}
